import React from 'react';
import { Field } from 'react-final-form';
import { Checkbox, FormControlLabel } from 'housecall-ui';

type Props = {
  label?: string;
};

const DEFAULT_LABEL =
  'By checking this box, I consent to receive marketing and promotional text messages at the phone number I have provided above. Message and data rates may apply.';

export const MarketingConsent = ({ label = DEFAULT_LABEL }: Props) => {
  return (
    <Field name="consent">
      {({ input }) => (
        <FormControlLabel
          data-testid="marketing-consent"
          control={
            <Checkbox
              value="consent"
              checked={input.value}
              color="primary"
              onChange={(event) => input.onChange(event.target.checked)}
            />
          }
          label={label}
        />
      )}
    </Field>
  );
};
